import { formatBuildDetail, formatBuildLabel } from '@inou/shared';
import { useState } from 'react';

import { BUILD_INFO } from '@/lib/build-info';
import { cn } from '@/lib/utils';

/**
 * いま動いているバンドルの版数。
 *
 * 押すとコピーできるのは、問い合わせのときにこれを貼ってもらうため。
 * 表示は短く (`v0.9.1 (a3f21c8)`)、コピーはビルド時刻まで含める。
 *
 * クリップボードが使えない環境 (非セキュアオリジン・権限拒否) では黙って
 * 諦める。文字は選択できるので経路は残る (`ui/copy-button.tsx` と同じ判断)。
 */
export function BuildStamp({ className }: { className?: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(formatBuildDetail(BUILD_INFO));
    } catch {
      return;
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  }

  return (
    <button
      type="button"
      onClick={copy}
      aria-live="polite"
      title={formatBuildDetail(BUILD_INFO)}
      className={cn('text-left font-mono text-[11px] text-ink-subtle hover:text-ink', className)}
    >
      {copied ? 'コピーしました' : formatBuildLabel(BUILD_INFO)}
    </button>
  );
}
